module.exports = __webpack_public_path__ + "static/media/mytologi.322f3355.jpg";